import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home'
import Details from '@/views/Details'
import Products from '@/views/Products'
import AboutUs from '@/views/AboutUs'
import SendUs from '@/views/SendUs'

import VueCookies from 'vue-cookies'


Vue.use(VueRouter)

/**
 * 路由配置
 */
const routes = [

    {path: '/', redirect: '/home'},
    {path: '/home', component: Home},
    {path: '/details', component: Details},
    {path: '/products', component: Products},
    {path: '/aboutUs', component: AboutUs},
    {path: '/sendUs', component: SendUs},
]

const router = new VueRouter({
    routes
})

/**
 * 路由守卫
 */
router.beforeEach((to, from, next) => {
    if (to.path === '/home' || to.path === '/') {
        next()
    } else {
        next()
    }
})
export default router
